import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DynamicComponent } from '@priva/components/dynamic';

import { AppState } from 'app/state';

@Component({
    selector: 'gm-main',
    templateUrl: './app-main.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AppMainComponent {
    activeDialogs$: Observable<DynamicComponent[]>;
    activePanel$: Observable<DynamicComponent | undefined>;

    /* istanbul ignore next, simple select */
    constructor(private store: Store<{ app: AppState }>) {
        this.activeDialogs$ = this.store.select(({ app }) => app.activeDialogs);
        this.activePanel$ = this.store.select(({ app }) => app.activePanel);
    }
}
